import React from "react";
import styled from "styled-components";

/**
 * Render a placeholder loading skeleton for texts
 * @param {string} width
 * @param {string} className
 * @returns {node}
 */

const TextSkeletonStyle = styled.div`
  width: ${(props) => props.width || "100%"};
`;

export const TextSkeleton = ({ className = "", width }) => {
  return (
    <TextSkeletonStyle
      width={width}
      className={"bg-gray-300 animate-pulse transform rounded-md h-6 " + className}
    />
  );
};

export const CustomTextSkeleton = ({ className = "", width, height = "" }) => {
  return (
    <TextSkeletonStyle
      width={width}
      style={{
        height,
      }}
      className={"bg-gray-300 animate-pulse transform rounded-md " + className}
    />
  );
};
